'use client';

import { Box } from '@doist/marketist';
import { useTranslation } from 'app/i18n/client';
import { MainPageHeader } from 'components/main-page-header/main-page-header';
import { useLocale } from 'next-intl';
import { HeroIllustration, PlatformLinks } from '../common/common';
import css from './header.module.css';
import type { Platform } from '../../services/valid-platforms';
type HeaderProps = {
  platform: Platform;
};
function Header({
  platform
}: HeaderProps) {
  const locale = useLocale();
  const {
    t
  } = useTranslation(locale, 'downloads');
  return <Box className={css.header} data-sentry-element="Box" data-sentry-component="Header" data-sentry-source-file="header.tsx">
            <HeroIllustration data-sentry-element="HeroIllustration" data-sentry-source-file="header.tsx" />
            <Box className={css.copy} data-sentry-element="Box" data-sentry-source-file="header.tsx">
                <MainPageHeader size="sm" style={{
        '--top-padding': '0px'
      }} title={t(`platform.${platform}.title`)} padded={false} subtitle={<PlatformLinks />} data-sentry-element="MainPageHeader" data-sentry-source-file="header.tsx" />
            </Box>
        </Box>;
}
export { Header };